import React from 'react';

const testimonials = [
  {
    quote: "Took my Porsche 911 in expecting good results — left genuinely impressed. Meticulous, professional, and they clearly know what they're doing with high-end paint.",
    name: 'Michael Rodriguez',
    location: 'Newport Beach, CA',
    vehicle: 'Porsche 911',
    stars: 5,
  },
  {
    quote: "My Range Rover has never looked this good — not even when I drove it off the lot. DA1MAMBA is the only team I\'ll trust with it going forward.",
    name: 'Jennifer Chen',
    location: 'Irvine, CA',
    vehicle: 'Range Rover',
    stars: 5,
  },
  {
    quote: "I have a collection and I've tried everyone. DA1MAMBA is the only service that treats each car like it's their own. Consistent, careful, and genuinely excellent.",
    name: 'David Kim',
    location: 'Orange County, CA',
    vehicle: 'Collector',
    stars: 5,
  },
];

export default function Testimonials() {
  return (
    <section style={{ padding: '120px 0', background: 'var(--mamba-black)' }}>
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="label-gold mb-4 reveal" style={{ justifyContent: 'center' }}>
            <span style={{ width: '32px', height: '1px', background: 'var(--mamba-gold-light)', display: 'inline-block' }} />
            Client Reviews
            <span style={{ width: '32px', height: '1px', background: 'var(--mamba-gold-light)', display: 'inline-block' }} />
          </div>
          <h2
            className="section-heading reveal reveal-delay-1"
            style={{ fontSize: 'clamp(28px, 3.5vw, 44px)' }}
          >
            Don't take our word for it.
          </h2>
        </div>

        {/* Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials?.map((t, i) => (
            <div
              key={i}
              className="testimonial-card reveal"
              style={{ transitionDelay: `${i * 0.12}s` }}
            >
              {/* Stars */}
              <div className="flex gap-1 mb-5" style={{ position: 'relative', zIndex: 1 }}>
                {Array.from({ length: t?.stars })?.map((_, si) => (
                  <svg key={si} width="14" height="14" fill="var(--mamba-gold-light)" viewBox="0 0 24 24">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                  </svg>
                ))}
              </div>

              <p style={{ color: 'var(--cool-gray)', fontSize: '15px', lineHeight: '1.7', fontFamily: 'DM Sans, sans-serif', marginBottom: '24px', position: 'relative', zIndex: 1 }}>
                "{t?.quote}"
              </p>

              <div style={{ borderTop: '1px solid rgba(107,33,168,0.15)', paddingTop: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                <div>
                  <div style={{ fontFamily: 'Manrope, sans-serif', fontWeight: 700, fontSize: '14px', color: 'var(--white)' }}>
                    {t?.name}
                  </div>
                  <div style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '12px', color: 'var(--gray-dim)' }}>
                    {t?.location}
                  </div>
                </div>
                <div style={{
                  background: 'rgba(107,33,168,0.12)',
                  border: '1px solid rgba(107,33,168,0.25)',
                  padding: '4px 10px',
                  fontSize: '11px',
                  fontFamily: 'Manrope, sans-serif',
                  fontWeight: 600,
                  color: 'var(--mamba-purple-bright)',
                  letterSpacing: '0.04em',
                }}>
                  {t?.vehicle}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Google Reviews link */}
        <div className="flex justify-center mt-10 reveal">
          <a
            href="https://share.google/GDSnfBC9lym6FSYWm"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-ghost"
            style={{ fontSize: '13px', padding: '12px 24px' }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
            </svg>
            View Google Reviews
          </a>
        </div>
      </div>
    </section>
  );
}
